import { useQuery } from "@tanstack/react-query";
import { S } from "../../styles";
import { LoadingState, ErrorState } from "../../components/QueryStates";

interface HealthStatus {
  status: string;
  service: string;
  environment: string;
  timestamp: string;
}

export function HealthPanel() {
  const {
    data: health,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["health"],
    queryFn: () =>
      fetch("/api/health").then((r) => r.json() as Promise<HealthStatus>),
    staleTime: 10_000,
  });

  if (isLoading) return <LoadingState label="Checking API status…" />;
  if (error) return <ErrorState error={error} />;

  return (
    <div style={S.card}>
      <h2 style={S.h2}>API Status</h2>
      {health && (
        <dl
          style={{
            display: "grid",
            gridTemplateColumns: "140px 1fr",
            gap: "6px 16px",
            margin: 0,
          }}
        >
          <dt style={{ fontWeight: 500 }}>Status</dt>
          <dd
            style={{
              color: health.status === "ok" ? "#27ae60" : "#c0392b",
              margin: 0,
            }}
          >
            {health.status}
          </dd>
          <dt style={{ fontWeight: 500 }}>Service</dt>
          <dd style={{ margin: 0 }}>{health.service}</dd>
          <dt style={{ fontWeight: 500 }}>Environment</dt>
          <dd style={{ margin: 0 }}>{health.environment}</dd>
        </dl>
      )}
    </div>
  );
}
